export default {
  'start': [],
  'intro': [
    { 'type': 'quiz', 'x': '26%', 'y': '58%', 'modal': 'intro-bike' },
    { 'type': 'quiz', 'x': '37%', 'y': '43%', 'modal': 'intro-pupils' },
    { 'type': 'quiz', 'x': '51%', 'y': '55%', 'modal': 'intro-trees' },
    { 'type': 'quiz', 'x': '62%', 'y': '26%', 'modal': 'intro-solar' },
    { 'type': 'quiz', 'x': '76%', 'y': '59%', 'modal': 'intro-bin' }
  ],
  'school-grounds': [
    { 'type': 'quiz', 'x': '10%', 'y': '33%', 'modal': 'bird-feeders' },
    { 'type': 'quiz', 'x': '31%', 'y': '35%', 'modal': 'polytunnel' },
    { 'type': 'quiz', 'x': '61%', 'y': '57%', 'modal': 'composting' },
    { 'type': 'quiz', 'x': '70%', 'y': '26.5%', 'modal': 'green-roof' },
    { 'type': 'quiz', 'x': '88%', 'y': '59%', 'modal': 'water-butt' }
  ],
  'classroom': [
    { 'type': 'quiz', 'x': '16%', 'y': '48%', 'modal': 'computers' },
    { 'type': 'quiz', 'x': '30%', 'y': '61%', 'modal': 'recycling-paper' },
    { 'type': 'quiz', 'x': '38%', 'y': '61%', 'modal': 'recycling-plastic' },
    { 'type': 'quiz', 'x': '55.5%', 'y': '54%', 'modal': 'water-bottle' },
    { 'type': 'quiz', 'x': '60%', 'y': '35%', 'modal': 'books' }
  ],
  'corridor': [
    { 'type': 'quiz', 'x': '13%', 'y': '37%', 'modal': 'posters' },
    { 'type': 'quiz', 'x': '33%', 'y': '16%', 'modal': 'lights' },
    { 'type': 'quiz', 'x': '49%', 'y': '34%', 'modal': 'noticeboard' },
    { 'type': 'quiz', 'x': '60%', 'y': '57%', 'modal': 'crisp-bin' },
    { 'type': 'quiz', 'x': '67.7%', 'y': '61%', 'modal': 'litter-pickers' }
  ],
  'bathroom': [
    { 'type': 'quiz', 'x': '15%', 'y': '50%', 'modal': 'cistern' },
    { 'type': 'quiz', 'x': '36%', 'y': '46%', 'modal': 'toilet' },
    { 'type': 'quiz', 'x': '58%', 'y': '40%', 'modal': 'hand-dryer' },
    { 'type': 'quiz', 'x': '71%', 'y': '41%', 'modal': 'hand-soap' },
    { 'type': 'quiz', 'x': '78%', 'y': '49%', 'modal': 'sensor-taps' }
  ],
  'canteen': [
    { 'type': 'quiz', 'x': '20.5%', 'y': '57%', 'modal': 'meals' },
    { 'type': 'quiz', 'x': '32%', 'y': '35%', 'modal': 'staff' },
    { 'type': 'quiz', 'x': '32%', 'y': '25%', 'modal': 'fairtrade-food' },
    { 'type': 'quiz', 'x': '65%', 'y': '45%', 'modal': 'cups-plates' },
    { 'type': 'quiz', 'x': '73%', 'y': '55%', 'modal': 'recycling-bins' }
  ]
}



// WEBPACK FOOTER //
// ./src/modalData.js